export type Status = 'Active' | 'Archived';

export const statuses: Status[] = ['Active', 'Archived'];

export const is = (s: string): s is Status => statuses.includes(s as Status);
